import axios from 'axios';
import { adsApi } from '@/api/client';
import type { CampaignAdProduct } from '@/types/spCampaigns';
import type { AdGroupToggleState } from '@/utils/adGroupActiveState';

export const AD_GROUP_MISSING_MESSAGE = 'Ad group id is required';
export const AD_GROUP_CANNOT_TOGGLE_MESSAGE = 'This ad group cannot be enabled or paused';
export const AD_GROUP_ENABLED_MESSAGE = 'Ad group enabled';
export const AD_GROUP_PAUSED_MESSAGE = 'Ad group paused';
export const AD_GROUP_UPDATE_FALLBACK_MESSAGE = 'Failed to update ad group';
export const AD_GROUP_STATUS_UPDATE_FALLBACK_MESSAGE = 'Failed to update ad group status';

export function adGroupStateApiErrorMessage(
  error: unknown,
  fallback = AD_GROUP_UPDATE_FALLBACK_MESSAGE
): string {
  if (axios.isAxiosError(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail.trim();
    if (detail && typeof detail === 'object' && detail !== null) {
      const record = detail as { message?: unknown; error?: unknown };
      if (typeof record.message === 'string' && record.message.trim()) {
        return record.message.trim();
      }
    }
    return fallback;
  }
  if (error instanceof Error && error.message.trim()) return error.message.trim();
  return fallback;
}

export async function updateAdGroupState(args: {
  profileId: string;
  adGroupId: string;
  adProduct: CampaignAdProduct;
  state: AdGroupToggleState;
}): Promise<void> {
  const { profileId, adGroupId, adProduct, state } = args;
  if (!adGroupId.trim()) {
    throw new Error(AD_GROUP_MISSING_MESSAGE);
  }

  let res;
  if (adProduct === 'SP') {
    res = await adsApi.updateSpAdGroupState(profileId, adGroupId, { state });
  } else if (adProduct === 'SB') {
    res = await adsApi.updateSbAdGroupState(profileId, adGroupId, { state });
  } else if (adProduct === 'SD') {
    res = await adsApi.updateSdAdGroupState(profileId, adGroupId, { state });
  } else {
    throw new Error(`Unsupported ad product: ${String(adProduct)}`);
  }

  if (!res.success) {
    throw new Error(AD_GROUP_UPDATE_FALLBACK_MESSAGE);
  }
}
